import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Fragment } from 'react';
import { useHlsContext } from "../../context/Hls";
import { usePlaybackContext } from "../../context/Playback";
import { useResponsiveContext } from "../../context/Responsive";
import { useSubtitleContext } from "../../context/Subtitle";
import { useUIContext } from "../../context/UI";
import DesktopSheet from "./DesktopSheet";
import MobileSheet from "./MobileSheet";
import TabletSheet from "./TabletSheet";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Menu = function Menu() {
  var _usePlaybackContext = usePlaybackContext(),
    changeSpeed = _usePlaybackContext.changeSpeed;
  var _useHlsContext = useHlsContext(),
    changeQuality = _useHlsContext.changeQuality,
    changeAudio = _useHlsContext.changeAudio;
  var _useSubtitleContext = useSubtitleContext(),
    changeSubtitleLang = _useSubtitleContext.changeSubtitleLang;
  var _useUIContext = useUIContext(),
    hideActiveMenu = _useUIContext.hideActiveMenu;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var onDismiss = function onDismiss() {
    hideActiveMenu();
  };
  var onSpeedChange = function onSpeedChange(newSpeed) {
    changeSpeed(newSpeed);
    onDismiss();
  };
  var onQualityChange = function onQualityChange(newQuality) {
    changeQuality(newQuality);
    onDismiss();
  };
  var onSubtitlesChange = function onSubtitlesChange(subtitle) {
    changeSubtitleLang(subtitle);
    onDismiss();
  };
  var onAudioChange = function onAudioChange(audio) {
    changeAudio(audio);
    onDismiss();
  };
  var props = {
    onDismiss: onDismiss,
    onSpeedChange: onSpeedChange,
    onQualityChange: onQualityChange,
    onSubtitlesChange: onSubtitlesChange,
    onAudioChange: onAudioChange
  };
  if (playerSize.matches.md) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(DesktopSheet, _objectSpread({
        selector: ".cp-settings-btn",
        menuId: "settings"
      }, props)), /*#__PURE__*/_jsx(DesktopSheet, _objectSpread({
        selector: ".cp-cc-btn",
        menuId: "cc"
      }, props))]
    });
  }
  if (playerSize.matches.xs) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(TabletSheet, _objectSpread({
        selector: ".cp-player",
        menuId: "settings"
      }, props)), /*#__PURE__*/_jsx(TabletSheet, _objectSpread({
        selector: ".cp-player",
        menuId: "cc"
      }, props))]
    });
  }
  return /*#__PURE__*/_jsx(MobileSheet, _objectSpread({}, props));
};
export default Menu;